import { ProjectChapter } from './../../interfaces/project';
import { FlowchartLink } from './../../shared/models/flowchart-link.model';
import { DefaultReduxState } from './../../shared/redux/app.store';
import { FlowchartStep } from './../../shared/models/flowchart-step.model';
import { ProjectFlowchart } from '../../interfaces/project';

const startChapterId = generateId();
export const PROJECT_DATA_INITIAL_STATE: ProjectFlowchartState = {
	data: {
		chapters: [{
			id: startChapterId,
			title: 'Start'
		}],
		steps: {
			'id-startstep' : {
				id: 'id-startstep',
				isStart: true,
				title: 'START HERE',
				description: 'Click here to name your first step',
				stepsIn: [],
				stepsOut: [],
				entityType: 'mediaclip',
				x: 100,
				y: 240,
				width: 135,
				height: 85,
				chapterId: startChapterId
			}
		},
		stepLinks: {}
	},
	fromCommand: 'initialize'
};

export interface ProjectFlowchartState extends DefaultReduxState {
	data: ProjectFlowchart;
}


export function projectFlowchartDataReducer( state: ProjectFlowchartState, action: any ): ProjectFlowchartState {
	// console.warn('projectFlowchartDataReducer action type', action.type);
	// console.warn('projectFlowchartDataReducer state', JSON.stringify(state));
	let returnState = addMessage(copyTillSteps(state), action);
	switch ( action.type ) {

		default:
			// don't change a thing
			returnState = state;
			break;

		case 'FROM_LOAD':
		case 'FROM_GENERATION':
			returnState = addMessage(copyTillSteps(action.loadData), action);
			break;

		case 'ADD_STEP':
			// console.log('ADD NEW STEP: REDUCER');
			const newStep = { ...action.step };
			newStep.stepsIn = [ action.fromStep.id ];
			returnState.data.steps[newStep.id] = newStep;
			returnState.data.steps[action.fromStep.id] = { ...returnState.data.steps[action.fromStep.id] };
			returnState.data.steps[action.fromStep.id].stepsOut = [ ...returnState.data.steps[action.fromStep.id].stepsOut ];
			returnState.data.steps[action.fromStep.id].stepsOut.push(action.step.id);
			returnState.data = updateStepChapter(returnState.data, action.step);
			break;

		case 'DELETE_STEP':
			returnState = removeDeletedLinks(returnState, action.step);
			delete returnState.data.steps[action.step.id];
			break;

		case 'DELETE_ITEMS':
			returnState = deleteItems(returnState, action.items);
			break;

		case 'UPDATE_MULTIPLE_STEPS':
			returnState = updateMultipleSteps(returnState, action.steps);
			for (const stepKey in action.steps) {
				if (action.steps[stepKey]) {
					returnState.data = updateStepChapter(returnState.data, action.steps[stepKey]);
				}
			}
			break;

		case 'UPDATE_STEP':
			// console.warn('before', JSON.stringify(returnState.data.steps[action.step.id]))
			returnState.data.steps[action.step.id] = { ...returnState.data.steps[action.step.id], ...action.step };
			if (action.chapters) {
				returnState.data.chapters = copyChapters(action.chapters);
			}
			returnState.data = updateStepChapter(returnState.data, action.step);
			// console.warn('after', JSON.stringify(returnState.data.steps[action.step.id]))
			break;

		case 'DELETE_CHAPTER':
			const chapterIndex: number = action.chapterIndex;

			returnState.data.chapters = copyChapters(returnState.data.chapters);
			returnState.data.chapters[chapterIndex] = {...action.chapter};

			returnState.data.chapters.splice(chapterIndex, 1);

			returnState = updateStepColsToChapters(returnState, returnState.data.steps);
			break;

		case 'UPDATE_CHAPTERS':
			returnState.data.chapters = copyChapters(action.chapters);
			break;

		case 'UPDATE_CHAPTER':
			// console.warn('before', JSON.stringify(returnState.data.chapters))

			const index: number = action.chapterIndex;
			returnState.data.chapters = copyChapters(returnState.data.chapters);
			returnState.data.chapters[index] = {...action.chapter};
			// console.warn('after', JSON.stringify(returnState.data.chapters))
			break;

		case 'ADD_STEP_LINK':
			const fromStep = { ...returnState.data.steps[action.fromStep.id] };
			fromStep.stepsOut = [ ...fromStep.stepsOut ];

			const toStep = { ...returnState.data.steps[action.toStep.id] };
			toStep.stepsIn = [ ...toStep.stepsIn ];

			if (toStep.stepsOut.indexOf(toStep.id) === -1) {
				fromStep.stepsOut.push( toStep.id );
			}
			if (toStep.stepsIn.indexOf(fromStep.id) === -1) {
				toStep.stepsIn.push( fromStep.id );
			}

			const stepLinks = { ...returnState.data.stepLinks };

			if (action.stepLink) {
				stepLinks[action.stepLink.id] = { ...action.stepLink };
				returnState.data.stepLinks = stepLinks;
			}

			returnState.data.steps[action.fromStep.id] = fromStep;
			returnState.data.steps[action.toStep.id] = toStep;
			break;

		case '__INIT__':
		case 'CREATE_NEW':
			returnState = addMessage(PROJECT_DATA_INITIAL_STATE, action);
			break;
		// with tassign: (unwanted results for now, so not using tassign)
		// return tassign(state, {...state, ...{ flowchart: newFlowchart}, fromCommand: action.description});
		// return tassign(state, {flowchart: state.data.steps.concat(Object.assign({}, 2)), fromCommand: action.description});
	}

	if (state === returnState) {
		// console.warn('================= projectDataReducer NO CHANGE');
	} else {
		// console.warn('================= projectDataReducer ' + action.type, 'fromState', state, 'newState', returnState);
	}
	return returnState;
}

function copyTillSteps(state: ProjectFlowchartState): ProjectFlowchartState {
	const newState = state ? { ...state } : { data: { steps: {} } } as ProjectFlowchartState;
	newState.data = newState.data ? { ...newState.data} : { steps: {}};
	newState.data.steps = newState.data.steps ? { ...newState.data.steps} : {};
	return newState;
}

function copyChapters(updatedChapters: ProjectChapter[]) {
	const newChapters = [...updatedChapters];
	updatedChapters.forEach((updatedChapter, i) => {
		newChapters[i] = { ...updatedChapter };
	});
	return newChapters;
}

function updateStepChapter(flowchart: ProjectFlowchart, step: FlowchartStep) {
	const newFlowchart = { ...flowchart };
	const chapters = flowchart.chapters;
	if (chapters[step.col]) {
		flowchart.steps[step.id].chapterId = chapters[step.col].id;
	} else {
		let newChapterId;
		while ( step.col >= chapters.length) {
			// generate a new column as long as we've not reached the desired step.col
			newChapterId = generateId();
			chapters[chapters.length] = {
				id: newChapterId,
				title: chapters.length === 0 ? 'Start' : 'Chapter ' + chapters.length
			};
		}
		// assign chapterId to last generated column
		if (flowchart.steps[step.id]) {
			flowchart.steps[step.id].chapterId = newChapterId;
		}
	}

	return newFlowchart;
}

function generateId() {
	return 'c' + Math.random().toString(36).substr(2, 16);
}

function removeDeletedLinks(state: ProjectFlowchartState, deletedStep: FlowchartStep): ProjectFlowchartState {
	const newState = copyTillSteps(state);
	deletedStep.stepsIn.forEach( (fromStepId: string ) => {
		const fromStep = { ...newState.data.steps[fromStepId] };
		if ( ! fromStep || ! fromStep.stepsOut ) {
			return false;
		}
		fromStep.stepsOut = [ ...fromStep.stepsOut ];
		const delIndex = fromStep.stepsOut.indexOf(deletedStep.id);
		if (delIndex > -1) {
			fromStep.stepsOut.splice(delIndex, 1);
		}
		newState.data.steps[fromStepId] = fromStep;
	});

	deletedStep.stepsOut.forEach( (toStepId: string ) => {
		const toStep = { ...newState.data.steps[toStepId] };
		if ( ! toStep || ! toStep.stepsIn ) {
			return false;
		}
		toStep.stepsIn = [ ...toStep.stepsIn ];
		const delIndex2 = toStep.stepsIn.indexOf(deletedStep.id);
		if (delIndex2 > -1) {
			toStep.stepsIn.splice(delIndex2, 1);
		}
		newState.data.steps[toStepId] = toStep;
	});
	return newState;
}

function updateStepColsToChapters(state: ProjectFlowchartState, items: (FlowchartStep | FlowchartLink)[]): ProjectFlowchartState {
	const newState = copyTillSteps(state);
	const chapterIndices = {};
	const chapters = newState.data.chapters;

	chapters.forEach((chapter: any, i: number) => {
		chapterIndices[chapter.id] = i;
	});

	Object.keys(items).forEach( (itemId: string) => {
		if (newState.data.steps[itemId]) {
			newState.data.steps[itemId] = { ...items[itemId] };
			const step = newState.data.steps[itemId];
			const chapterIndex = chapterIndices[step.chapterId];
			step.col = chapterIndex;
		}
	});
	return newState;
}

function updateMultipleSteps(state: ProjectFlowchartState, items: (FlowchartStep | FlowchartLink)[]): ProjectFlowchartState {
	const newState = copyTillSteps(state);

	Object.keys(items).forEach( (itemId: string) => {
		// only position changes for now (on root level so no deeper copy needed)
		if (newState.data.steps[itemId]) {
			newState.data.steps[itemId] = { ...items[itemId] };
		}
	});
	return newState;
}

function deleteItems(state: ProjectFlowchartState, items: (FlowchartStep | FlowchartLink)[]): ProjectFlowchartState {
	let newState = copyTillSteps(state);
	Object.keys(items).forEach( (itemId: string) => {
		const step = newState.data.steps[itemId];
		if (step && step.type === 'FlowchartStep' && ! step.isStart) {
			newState = removeDeletedLinks(newState, step);
			delete newState.data.steps[itemId];
		} else if (! step) {
			const parts = itemId.split('_TO_');
			if (parts.length === 2) {
				const fromStepId = parts[0];
				const toStepId = parts[1];
				const fromStep = { ...newState.data.steps[fromStepId]};
				const toStep = { ...newState.data.steps[toStepId]};
				if (fromStep && fromStep.stepsOut && fromStep.stepsOut.length) {
					const fcIndex2 = fromStep.stepsOut.indexOf(toStepId);
					if (fcIndex2 > -1) {
						fromStep.stepsOut = [ ...fromStep.stepsOut ];
						fromStep.stepsOut.splice(fcIndex2, 1);
						newState.data.steps[fromStep.id] = { ...fromStep};
					}
				}
				if (toStep && toStep.stepsIn && toStep.stepsIn.length) {
					const fcIndex = toStep.stepsIn.indexOf(fromStepId);
					if (fcIndex > -1) {
						toStep.stepsIn = [ ...toStep.stepsIn ];
						toStep.stepsIn.splice(fcIndex, 1);
						newState.data.steps[toStep.id] = { ...toStep};
					}
				}
			}
		}
	});
	return newState;
}

function addMessage(state: ProjectFlowchartState, action: any) {
	const newState = { ...state };
	newState.fromCommand = action.type; // translate?
	newState.type = action.type;
	return newState;
}
